import { Breadcrumbs } from '@/components/Breadcrumbs/Breadcrumbs';
import { ContactForm } from '@/components/Forms/ContactForm/ContactForm';
import { Container } from '@/components/Container/Container';
import { PublicPage } from '@/components/Page/PublicPage';
import { ESize } from '@/models/enums';
import { NextPage } from 'next';

const ContactNextPage: NextPage = () => {
  return (
    <PublicPage
      meta={{
        seoDescription: 'Send an email for further information or questions',
        seoTitle: 'Contact',
      }}
      title="Contact"
    >
      <Container additionalClassNames="py-12" size={ESize.XS}>
        <div className="mb-2">
          <Breadcrumbs items={[{ content: <span>Contact</span>, key: 'Contact' }]} />
        </div>
        <h1 className="color-black text-uppercase mb-4">Contact</h1>
        <p className="mb-8">For further information or questions, email us.</p>
        <ContactForm />
      </Container>
    </PublicPage>
  );
};

export default ContactNextPage;
